// ¿Puede la persona (la efectiva si dirección simula a un empleado) cambiar
// las horas de los servicios, su tipo y "Acompaña a"? Solo quien tiene el
// módulo de presupuestos: la regla de App.js (`routePermissions['/presupuestos']`,
// permisos finos y si no el rol), la misma que el servidor (`exigir_modulo`,
// 403). Decisión de dirección del 16-oct-2026: "Los de operaciones no pueden
// modificar horarios"; las ven en solo lectura.
import { useContext } from 'react';
import { useAuth } from '../context/AuthContext';
import { VistaEmpleadoContext } from '../context/VistaEmpleadoContext';

export const usePuedeEditarHorarios = () => {
  const { user } = useAuth() || {};
  const vista = useContext(VistaEmpleadoContext);
  // Fuera del proveedor (pruebas o pantallas sueltas) no se decide aquí: el
  // servidor manda
  if (!vista || typeof vista.puedeVerRuta !== 'function') return true;
  return !!vista.puedeVerRuta('/presupuestos', vista.usuarioEfectivo || user);
};

export default usePuedeEditarHorarios;
